/*
    Examiner Item content editor page wrapper

    This wrapper exists so that redirecting between examinee and examiner content editors ensures a re-init of the component with the new contentType.
*/

import ContentEditorPage from './content-editor-page';

const ExaminerContentEditorPage = () => {
  return <ContentEditorPage contentType="examiner" />;
};

export default ExaminerContentEditorPage;
